import { Link } from "react-router-dom";
import { Instagram, Youtube, Music2 } from "lucide-react";
import { useLang } from "@/context/LangContext";
import Stamp from "@/components/Stamp";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-matcha text-ink border-t border-ink" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] text-brand">
              Fight For<br />Yourself.
            </h2>
            <p className="mt-5 text-ink/70 text-lg font-medium max-w-md">{t.footerTagline}</p>
            <div className="flex gap-2 mt-7">
              {[Instagram, Music2, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="btn bg-cream text-ink w-11 h-11 p-0 hover:bg-ink hover:text-cream"
                  aria-label="social"
                >
                  <Icon className="w-4 h-4" strokeWidth={2} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 gap-8 lg:pl-16">
            <div>
              <p className="kicker text-ink/50 mb-4">Shop</p>
              <ul className="space-y-2.5 font-medium text-ink/75">
                <li><Link to="/shop" className="hover:text-pink transition-colors">{t.shop.supplement}</Link></li>
                <li><Link to="/shop" className="hover:text-pink transition-colors">{t.shop.merch}</Link></li>
                <li><Link to="/shop" className="hover:text-pink transition-colors">{t.shop.accessory}</Link></li>
                <li><Link to="/bundle" className="hover:text-pink transition-colors">{t.nav.bundle}</Link></li>
              </ul>
            </div>
            <div>
              <p className="kicker text-ink/50 mb-4">Club</p>
              <ul className="space-y-2.5 font-medium text-ink/75">
                <li><Link to="/movement" className="hover:text-pink transition-colors">{t.nav.movement}</Link></li>
                <li><Link to="/creators" className="hover:text-pink transition-colors">{t.nav.creators}</Link></li>
                <li><Link to="/lookbook" className="hover:text-pink transition-colors">{t.nav.lookbook}</Link></li>
                <li><Link to="/#social" className="hover:text-pink transition-colors">{t.nav.social}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-ink/15 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-ink/60 text-xs md:text-sm max-w-xl text-center md:text-left">
            © {new Date().getFullYear()} ANTI UNHEALTHY CLUB™ · CRTR Studio. {t.footerRights}
          </p>
          <Stamp size={84} bg="bg-cream" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
